module.exports = __webpack_public_path__ + "static/media/entregarinju8.e49384f0.jpg";